import React from 'react';
import { useLazyComponent } from '../../hooks/usePerformance';
import SkeletonLoader from './SkeletonLoader';

interface LazySectionProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  className?: string;
  threshold?: number;
}

const LazySection: React.FC<LazySectionProps> = ({
  children,
  fallback,
  className = '',
  threshold = 0.1,
}) => {
  const { shouldLoad, setElementRef } = useLazyComponent({ threshold });

  if (!shouldLoad) {
    return (
      <div ref={setElementRef} className={className}>
        {fallback || (
          <div className="py-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <SkeletonLoader height={200} className="mb-8" />
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[...Array(3)].map((_, i) => (
                  <SkeletonLoader key={i} height={150} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div ref={setElementRef} className={className}>
      {children}
    </div>
  );
};

export default LazySection;